import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { EventsComponent } from "../../components/events"

export const EventsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <EventsComponent />
    </DefaultPageComp>
  </>
}